module.exports = __webpack_public_path__ + "img/almatyObl3.79481c56.jpg";